function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalaxy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 501.761 501.761",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M294.506,367.683c-0.66,0.563-1.321,1.123-1.982,1.681 C293.185,368.806,293.846,368.245,294.506,367.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M300.426,362.577c-0.582,0.508-1.164,1.01-1.746,1.515 C299.262,363.587,299.844,363.086,300.426,362.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M288.344,372.861c-0.583,0.484-1.167,0.971-1.75,1.452C287.177,373.832,287.76,373.345,288.344,372.861 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M249.17,402.61c-0.539,0.372-1.078,0.737-1.617,1.106C248.093,403.347,248.631,402.982,249.17,402.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M313.853,350.483c-0.588,0.545-1.175,1.093-1.763,1.634 C312.678,351.576,313.265,351.028,313.853,350.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M262.673,392.963c-0.57,0.421-1.141,0.845-1.711,1.262 C261.532,393.808,262.103,393.383,262.673,392.963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M268.855,388.338c-0.648,0.492-1.295,0.981-1.943,1.469 C267.56,389.319,268.207,388.829,268.855,388.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M442.585,175.573c-0.493,1.198-0.995,2.4-1.51,3.607C441.59,177.973,442.092,176.772,442.585,175.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M437.634,54.36c0.077,0.062,0.151,0.128,0.228,0.191C437.785,54.489,437.711,54.422,437.634,54.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M439.68,56.089c0.698,0.625,1.382,1.265,2.047,1.93C441.062,57.354,440.379,56.711,439.68,56.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M243.253,406.632c-0.628,0.421-1.256,0.84-1.884,1.256 C241.997,407.471,242.625,407.053,243.253,406.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M325.757,339.172c-0.585,0.571-1.172,1.134-1.758,1.701 C324.585,340.306,325.172,339.742,325.757,339.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M319.927,344.783c-0.66,0.628-1.321,1.253-1.982,1.877C318.606,346.036,319.267,345.41,319.927,344.783 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M274.809,383.758c-0.567,0.443-1.135,0.878-1.702,1.318 C273.674,384.637,274.241,384.201,274.809,383.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M43.241,362.478c-0.061,0.258-0.123,0.517-0.183,0.775C43.118,362.996,43.18,362.737,43.241,362.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M42.328,366.548c-0.031,0.148-0.063,0.296-0.094,0.443C42.265,366.844,42.296,366.696,42.328,366.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M47.435,347.292c0.005-0.017,0.01-0.035,0.016-0.052c-0.005,0.016-0.011,0.033-0.015,0.048 L47.435,347.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M44.255,358.381c-0.085,0.327-0.173,0.656-0.255,0.983C44.082,359.038,44.17,358.709,44.255,358.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M45.331,354.385c-0.091,0.324-0.187,0.651-0.276,0.974C45.144,355.035,45.24,354.709,45.331,354.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M48.769,343.208c-0.418,1.195-0.806,2.378-1.162,3.549C47.982,345.579,48.371,344.396,48.769,343.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M237.11,410.68c-0.547,0.355-1.095,0.714-1.641,1.065C236.016,411.394,236.563,411.035,237.11,410.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M448.772,159.125c14.809-43.794,13.635-80.427-7.044-101.105h0 C462.407,78.698,463.581,115.331,448.772,159.125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C546A"
    },
    d: "M477.729,22.02c-56.681-56.681-205.096-0.162-331.494,126.237 C301.69,26.208,386.373,32.094,420.799,45.168c6.279,2.178,11.918,5.232,16.835,9.192c0.077,0.062,0.151,0.128,0.228,0.191 c0.615,0.501,1.227,1.008,1.819,1.538c0.699,0.623,1.382,1.265,2.047,1.93c0,0,0.001,0.001,0.001,0.001v0h0 c20.678,20.678,21.853,57.311,7.044,101.105c-1.819,5.378-3.892,10.87-6.187,16.448c-0.493,1.198-0.995,2.4-1.51,3.607 c-20.626,48.373-58.534,103.284-109.584,154.334c-1.906,1.906-3.819,3.788-5.735,5.658c-0.585,0.571-1.172,1.134-1.758,1.701 c-1.355,1.312-2.712,2.616-4.072,3.91c-0.66,0.628-1.32,1.253-1.982,1.877c-1.362,1.285-2.727,2.558-4.093,3.824 c-0.588,0.545-1.175,1.093-1.763,1.634c-3.875,3.563-7.764,7.05-11.663,10.46c-0.582,0.509-1.164,1.01-1.746,1.515 c-1.39,1.206-2.781,2.404-4.174,3.591c-0.661,0.563-1.321,1.123-1.982,1.681c-1.393,1.176-2.786,2.341-4.18,3.497 c-0.583,0.484-1.167,0.971-1.75,1.452c-3.925,3.23-7.855,6.379-11.785,9.446c-0.568,0.443-1.135,0.878-1.702,1.318 c-1.417,1.097-2.834,2.186-4.251,3.262c-0.648,0.492-1.295,0.981-1.943,1.469c-1.414,1.063-2.826,2.115-4.239,3.156 c-0.57,0.421-1.141,0.845-1.711,1.262c-3.937,2.88-7.869,5.676-11.792,8.385c-0.539,0.372-1.078,0.737-1.617,1.106 c-1.435,0.983-2.868,1.956-4.301,2.915c-0.628,0.421-1.256,0.839-1.884,1.256c-1.421,0.943-2.841,1.873-4.259,2.792 c-0.547,0.355-1.095,0.714-1.641,1.065c-1.937,1.246-3.872,2.475-5.802,3.677c94.887-57.2,214.697-151.023,258.415-267.47 C505.886,93.897,503.887,48.178,477.729,22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C546A"
    },
    d: "M42.234,366.992c0.031-0.148,0.062-0.296,0.094-0.443c0.232-1.092,0.474-2.19,0.73-3.295 c0.06-0.258,0.122-0.517,0.183-0.775c0.244-1.034,0.494-2.07,0.758-3.114c0.083-0.326,0.171-0.655,0.255-0.983 c0.26-1.004,0.522-2.01,0.8-3.023c0.089-0.323,0.185-0.65,0.276-0.974c0.656-2.342,1.35-4.703,2.104-7.093l0-0.004 c0.005-0.016,0.01-0.032,0.015-0.048c0.051-0.161,0.105-0.323,0.156-0.483c0.356-1.171,0.744-2.354,1.162-3.549 c17.77-52.968,59.005-116.492,117.465-174.951c39.73-39.73,81.799-71.501,121.305-93.363 C35.723,211.774-36.148,423.606,19.997,479.751c47.452,47.452,159.198,15.527,268.495-70.28 c-184.956,94.549-232.601,54.07-244.957,14.421C37.86,408.438,37.614,389.008,42.234,366.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74749B"
    },
    d: "M237.11,410.68c1.418-0.92,2.837-1.849,4.259-2.792c0.628-0.417,1.256-0.835,1.884-1.256 c1.432-0.96,2.866-1.932,4.301-2.915c0.539-0.369,1.078-0.734,1.617-1.106c3.923-2.709,7.855-5.505,11.792-8.385 c0.57-0.417,1.14-0.841,1.711-1.262c1.413-1.042,2.826-2.093,4.239-3.156c0.648-0.487,1.295-0.977,1.943-1.469 c1.417-1.076,2.834-2.164,4.251-3.262c0.568-0.439,1.135-0.875,1.702-1.318c3.93-3.067,7.86-6.216,11.785-9.446 c0.584-0.48,1.167-0.968,1.75-1.452c1.394-1.156,2.788-2.321,4.18-3.497c0.661-0.558,1.321-1.119,1.982-1.681 c1.392-1.186,2.783-2.384,4.174-3.591c0.582-0.505,1.164-1.006,1.746-1.515c3.899-3.409,7.788-6.896,11.663-10.46 c0.589-0.541,1.176-1.09,1.763-1.634c1.366-1.266,2.73-2.539,4.093-3.824c0.661-0.623,1.322-1.249,1.982-1.877 c1.36-1.293,2.717-2.598,4.072-3.91c0.586-0.567,1.173-1.131,1.758-1.701c1.916-1.869,3.829-3.752,5.735-5.658 c51.05-51.05,88.958-105.961,109.584-154.334c0.515-1.207,1.017-2.409,1.51-3.607c2.294-5.578,4.368-11.07,6.187-16.448 c14.809-43.793,13.635-80.427-7.044-101.105v0c0,0-0.001-0.001-0.001-0.001c-0.665-0.665-1.35-1.305-2.047-1.93 c-0.592-0.53-1.203-1.036-1.819-1.538c-0.077-0.063-0.151-0.129-0.228-0.191c-4.917-3.96-10.556-7.014-16.835-9.192 c-31.924-11.076-80.285,0.41-133.26,29.725c-39.506,21.862-81.575,53.633-121.305,93.363 C107.775,226.715,66.54,290.24,48.769,343.208c-0.399,1.188-0.787,2.371-1.162,3.549c-0.051,0.161-0.105,0.323-0.156,0.483 c-0.005,0.017-0.01,0.035-0.016,0.052c-0.755,2.389-1.448,4.75-2.104,7.093c-0.091,0.324-0.187,0.651-0.276,0.974 c-0.279,1.013-0.541,2.019-0.8,3.023c-0.085,0.327-0.173,0.656-0.255,0.983c-0.265,1.044-0.514,2.081-0.758,3.114 c-0.061,0.258-0.123,0.517-0.183,0.775c-0.256,1.105-0.498,2.203-0.73,3.295c-0.031,0.148-0.063,0.296-0.094,0.443 c-4.621,22.017-4.374,41.446,1.301,56.9c2.808,7.646,6.931,14.328,12.462,19.859c31.385,31.385,99.526,17.84,173.67-28.329 c1.93-1.202,3.865-2.432,5.802-3.677C236.016,411.394,236.563,411.035,237.11,410.68z M91.997,407.751 c-32.38-32.38,11.602-128.86,98.237-215.495S373.349,61.64,405.729,94.019s-11.602,128.86-98.237,215.495 C220.857,396.149,124.377,440.131,91.997,407.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB293"
    },
    d: "M405.729,94.019c-32.38-32.38-128.86,11.602-215.495,98.237S59.617,375.371,91.997,407.751 c32.38,32.38,128.86-11.602,215.495-98.237C394.126,222.879,438.108,126.399,405.729,94.019z M138.296,361.452 c-20.355-20.355,12.647-86.358,73.711-147.423s127.068-94.066,147.423-73.711c20.355,20.355-12.647,86.358-73.711,147.423 C224.654,348.805,158.651,381.807,138.296,361.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF2AA"
    },
    d: "M359.43,140.318c-20.355-20.355-86.358,12.647-147.423,73.711s-94.066,127.068-73.711,147.423 c20.355,20.355,86.358-12.647,147.423-73.711C346.783,226.676,379.785,160.673,359.43,140.318z M263.605,265.628 c-32.568,32.568-65.569,52.369-73.711,44.227c-8.142-8.142-0.354-53.157,32.214-85.725c32.568-32.568,77.583-40.356,85.725-32.214 C315.974,200.058,296.173,233.06,263.605,265.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M222.107,224.13c-32.568,32.568-40.356,77.583-32.214,85.725 c8.142,8.142,41.144-11.659,73.711-44.227c32.568-32.568,52.369-65.569,44.227-73.711 C299.69,183.774,254.675,191.562,222.107,224.13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalaxy);
export default __webpack_public_path__ + "static/media/galaxy.be186547219fdbead7960c0656463b3f.svg";
export { ForwardRef as ReactComponent };